import { RemainingEngineeringScopeWrapper } from './styles';

import ImageViewer from '../ImageViewer';
import { getImagesArray } from '../../hooks/useImagesArray';

const RemainingEngineeringScope = ({ images }) => {
  const { imageArray } = getImagesArray(images || [], 10);

  return (
    <RemainingEngineeringScopeWrapper>
      <ImageViewer
        imageId={imageArray[9].imageId}
        containerStyle={{
          width: '100%',
          height: '400px',
        }}
      />
    </RemainingEngineeringScopeWrapper>
  );
};

export default RemainingEngineeringScope;
